class ModalPopup extends HTMLElement {
  constructor() {
    super();

    const PopupButton = document.querySelector('#sizeGuide_popup');
    const modal = document.querySelector('.sizeGuide_modal');
    const closeBtn = document.querySelector('.sizeGuide_modal-close');

    PopupButton.addEventListener('click', () => {
      console.log('click');

      if (modal.classList.contains('tw-hidden')) {
        modal.classList.remove('tw-hidden');
      } else {
        modal.classList.add('tw-hidden');
      }
    });

    closeBtn.addEventListener('click', () => {
      modal.classList.add('tw-hidden');
    });
  }
}
customElements.define('modal-popup', ModalPopup);
